import React from "react";
import "./SelectField.css";

interface Option {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  name: string;
  value?: string;
  defaultOption?: string;
  options: Option[];
  disabled?: boolean;
  onChange: (name: string, value: string) => void;
  error?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  name,
  value,
  defaultOption,
  options,
  disabled,
  onChange,
  error,
}) => {
  return (
    <div className="select-input-container">
      <label className="select-input-label" htmlFor={name}>{label}</label>
      <select
        className={`select-field ${error ? "error-field" : ""}`}
        id={name}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        disabled={disabled}>
        {defaultOption && <option value="">{defaultOption}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  )
};

export default SelectField;
